import { useParams } from 'react-router-dom';
import {
    DeleteButton,
    EditBase,
    SaveButton,
    SimpleForm,
    Toolbar,
} from 'react-admin';
import { MunicipalityInputs } from './MunicipalityInputs';
import { MunicipalityFormCard } from './MunicipalityFormCard';

// Delete redirect is explicit because this resource isn't mounted at /municipalities.
const MunicipalityEditToolbar = () => (
    <Toolbar>
        <SaveButton />
        <DeleteButton redirect="/settings/municipalities" />
    </Toolbar>
);

// Reads :id from the nested Settings route; redirect uses the explicit Settings path.
// SimpleForm renders its own CardContent + full-width toolbar; wrap it in a bare Card.
export const MunicipalityEdit = () => {
    const { id } = useParams();
    return (
        <EditBase
            resource="municipalities"
            id={id}
            mutationMode="pessimistic"
            redirect="/settings/municipalities"
        >
            <MunicipalityFormCard>
                <SimpleForm sanitizeEmptyValues toolbar={<MunicipalityEditToolbar />}>
                    <MunicipalityInputs />
                </SimpleForm>
            </MunicipalityFormCard>
        </EditBase>
    );
};
